import React from "react";
import Button from "../../../shared/ui/Button";
import { useItemForm } from "../model/ItemFormContext";
import QuickItemGroupCreateModal from "../../item-groups/components/QuickItemGroupCreateModal";
import type { ItemGroupSummary } from "../../item-groups/item-groups.api";

interface ItemGroupActivationFieldsProps {
  item: { error_count?: number } | null;
  itemGroups: ItemGroupSummary[];
  onItemGroupCreated: (group: ItemGroupSummary) => void;
}

const ItemGroupActivationFields = ({ item, itemGroups, onItemGroupCreated }: ItemGroupActivationFieldsProps) => {
  const { register, errors, setValue, clearErrors } = useItemForm();
  const [createModalShow, setCreateModalShow] = React.useState(false);

  const handleCreated = (group: ItemGroupSummary) => {
    onItemGroupCreated(group);
    setValue("itemgroup_id", group.id, { shouldDirty: true, shouldValidate: true });
    clearErrors("itemgroup_id");
    setCreateModalShow(false);
  };

  return (
    <div className="row mt-3">
      <div className="col">
        <fieldset className="border-0 p-0 m-0">
          <legend className="float-none w-auto fs-6 fw-semibold mb-3 px-0">그룹·활성화</legend>
          <ul className="list-unstyled">
            <li className="mb-3">
              <div className="row">
                <div className="col">
                  <label className="form-label">상품그룹</label>
                  <div className="d-flex gap-2 align-items-start">
                    <select
                      id="id_itemgroup_id"
                      className={`form-select flex-grow-1 min-w-0 ${errors.itemgroup_id ? "is-invalid" : ""}`}
                      {...register("itemgroup_id")}
                    >
                      <option value="">-- 선택 --</option>
                      {itemGroups?.map((itemGroup) => (
                        <option key={itemGroup.id} value={itemGroup.id}>
                          {itemGroup.name}
                        </option>
                      ))}
                    </select>
                    <Button
                      type="button"
                      variant="outline"
                      className="flex-shrink-0"
                      onClick={() => setCreateModalShow(true)}
                    >
                      새 그룹
                    </Button>
                  </div>
                </div>
                <div className="col">
                  <label className="form-label">상품그룹 내 우선순위</label>
                  <input
                    type="number"
                    id="id_sort_order"
                    className={`form-control ${errors.sort_order ? "is-invalid" : ""}`}
                    {...register("sort_order", {
                      required: "우선순위를 입력하세요.",
                      min: { value: 0, message: "우선순위는 0 이상이어야 합니다." },
                    })}
                  />
                  {errors.sort_order && (
                    <div className="invalid-feedback">{errors.sort_order.message}</div>
                  )}
                  <div className="form-text" id="basic-addon4">
                    우선순위가 높을수록 위에 배치, 같은 순위 시 생성일시 순
                  </div>
                </div>
              </div>
              {errors.itemgroup_id && (
                <div className="invalid-feedback">{errors.itemgroup_id.message}</div>
              )}
              {errors.sort_order && (
                <div className="invalid-feedback">{errors.sort_order.message}</div>
              )}
            </li>

            {item && (
              <li className="mb-3">
                <label className="form-label">오류 누적 회수</label>
                <input
                  type="number"
                  id="id_error_count"
                  className="form-control"
                  value={item.error_count || 0}
                  disabled
                  readOnly
                />
                <div className="form-text">
                  작업 연속 오류 누적 횟수. 작업 성공 시 초기화. 5회 이상 연속
                  오류 시 작업 비활성화
                </div>
              </li>
            )}

            <li className="mb-3">
              <label className="form-label">작업 활성화</label>
              <input
                type="checkbox"
                id="is_active"
                className="form-check-input ms-2"
                {...register("is_active")}
              />
              {errors.is_active && (
                <div className="invalid-feedback d-block">{errors.is_active.message}</div>
              )}
            </li>
          </ul>
        </fieldset>
      </div>
      <QuickItemGroupCreateModal
        show={createModalShow}
        onHide={() => setCreateModalShow(false)}
        onCreated={handleCreated}
      />
    </div>
  );
};

export default ItemGroupActivationFields;
